import { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { PilotPayload } from './types'
import { PilotAvatar } from './pilot_avatar'
import { Table, TableBody, TableCell, TableRow } from '../components/table'

export function PilotList() {
  const navigate = useNavigate()
  const [pilots, setPilots] = useState<PilotPayload[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetch('/v0/pilots')
      .then(r => r.json())
      .then(data => setPilots(data.pilots ?? []))
      .finally(() => setIsLoading(false))
  }, [])

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-[#2D3142] dark:text-white">Pilots</h1>
          <p className="mt-2 text-sm text-[#4F5D75] dark:text-[#BFC0C0]">
            All registered pilots.
          </p>
        </div>
      </div>

      {isLoading ? (
        <div className="mt-6 animate-pulse space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-12 bg-[#BFC0C0]/30 rounded" />
          ))}
        </div>
      ) : pilots.length === 0 ? (
        <p className="mt-8 text-center text-sm text-[#4F5D75] dark:text-[#BFC0C0]">
          No pilots yet.
        </p>
      ) : (
        <div className="mt-6 bg-white dark:bg-[#2D3142] shadow-lg rounded-lg overflow-hidden">
          <Table>
            <TableBody>
              {pilots.map(p => (
                <TableRow
                  key={p.nick}
                  className="hover:bg-[#BFC0C0]/30 dark:hover:bg-[#4F5D75]/30 transition-colors cursor-pointer"
                  onClick={() => navigate(`/pilot/${p.nick}`)}
                >
                  <TableCell className="w-12">
                    <PilotAvatar pilot={p} className="size-8 bg-[#4F5D75]/20 text-[#4F5D75] dark:bg-[#BFC0C0]/20 dark:text-[#BFC0C0]" />
                  </TableCell>
                  <TableCell className="font-medium text-[#2D3142] dark:text-white">
                    {p.name}
                  </TableCell>
                  <TableCell className="text-sm text-[#4F5D75] dark:text-[#BFC0C0]">
                    <Link
                      to={`/pilot/${p.nick}`}
                      className="text-[#EF8354] hover:underline"
                      onClick={e => e.stopPropagation()}
                    >
                      @{p.nick}
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  )
}
